export default "__VITE_ASSET__DtETzUhf__"